import React from 'react';
import { Check, Download, FileSpreadsheet, FileText, Image as ImageIcon } from 'lucide-react';

interface ExportPanelProps {
    onExportExcel: () => void;
    onExportPdf: () => void;
    onCopyResumo: () => void;
    onExportImage: () => void;
    resumoCopiado: boolean;
    exportingImage: boolean;
}

/** Barra de exportação executiva — Excel/PDF/copiar resumo/imagem, todos gerados
 * client-side (sem round-trip ao servidor). */
const ExportPanel: React.FC<ExportPanelProps> = ({ onExportExcel, onExportPdf, onCopyResumo, onExportImage, resumoCopiado, exportingImage }) => {
    const btnClass = 'flex items-center gap-1.5 px-3 py-2 text-xs font-bold rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:border-primary hover:text-primary transition-colors disabled:opacity-50 disabled:cursor-default';
    return (
        <div className="flex items-center gap-2 flex-wrap">
            <button onClick={onExportExcel} className={btnClass} title="Exportar Excel">
                <FileSpreadsheet size={14} /> Excel
            </button>
            <button onClick={onExportPdf} className={btnClass} title="Exportar Relatório Executivo em PDF">
                <FileText size={14} /> PDF
            </button>
            <button onClick={onCopyResumo} className={btnClass} title="Copiar resumo executivo">
                {resumoCopiado ? <Check size={14} className="text-green-600" /> : <Download size={14} />} {resumoCopiado ? 'Copiado!' : 'Copiar resumo'}
            </button>
            <button onClick={onExportImage} disabled={exportingImage} className={btnClass} title="Exportar imagem (WhatsApp)">
                <ImageIcon size={14} /> {exportingImage ? 'Gerando...' : 'Imagem'}
            </button>
        </div>
    );
};

export default ExportPanel;
